module.exports = __webpack_public_path__ + "img/22.12cc3b5.jpg";